'use client';

import { c as _c } from "react/compiler-runtime";
import { LucideChevronDown } from 'lucide-react';
import Link from 'next/link';
import { LEARN_MORE_HEADER_SECTION_ID } from '../../shared/constants/section-ids';
import LearnMoreIntroBanner from './components/banner';
export function LearnMoreIntro() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LearnMoreIntroBanner />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative shadow-lg shadow-foreground/30 flex size-full items-center justify-start md:min-h-[900px] min-h-[700px]">{t0}<Link href={`#${LEARN_MORE_HEADER_SECTION_ID}`} aria-label="Rolar para baixo" className="absolute flex cursor-pointer items-end pb-8 justify-center bottom-0 w-full h-1/3 bg-linear-to-t from-clube-black/50 to-transparent p-6"><LucideChevronDown size={32} className="text-white" /></Link></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}